var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#256509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.35-61.17q-33.5 0-58.34-24.84-24.84-24.84-24.84-58.34v-503.78q0-33.73 24.84-58.74 24.84-25 58.34-25h94.56v-10q1.13-66.13 47.81-111.83 46.67-45.69 113.22-45.69t113.78 45.69q47.24 45.7 48.37 111.83v10h93.56q33.74 0 58.74 25 25 25.01 25 58.74v503.78q0 33.5-25 58.34-25 24.84-58.74 24.84h-511.3Zm0-83.18h511.3v-503.78h-93.56v77.91q0 17.79-12.48 29.94-12.48 12.15-29.79 12.15-16.88 0-28.89-12.15-12.02-12.15-12.02-29.94v-77.91H402.09v77.91q0 17.79-12.48 29.94-12.48 12.15-29.79 12.15-16.88 0-28.89-12.15-12.02-12.15-12.02-29.94v-77.91h-94.56v503.78Zm178.3-587.52h155.7v-10q-1.13-30.61-23.79-52.19-22.66-21.59-54.69-21.59-32.04 0-54.07 21.59-22.02 21.58-23.15 52.19v10Zm-178.3 587.52v-503.78 503.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.31e9205c4831a0dc1d28b65fffb74b5d.svg";
export { ForwardRef as ReactComponent };